import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType, CommonRoutes,
} from 'app/enums/common.enums'
import {
    LaneGroupTemperatureRange, LaneStatus,
    DeliveryServiceType, CollectionServiceType,
} from 'app/enums/label.enums'

import {
    UnassignedToOpportunity,
} from '../KamDashboard.types'

const toBeAssignedLanesConfig: SkyNetTableConfig<keyof UnassignedToOpportunity> = {
    name: 'toBeAssigned',
    tabs: [{
        name: 'To Be Assigned',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'laneNumber',
                labelKey: 'AccountLane.laneNumber',
            },
            {
                name: 'laneGroupNumber',
                labelKey: 'Lane.laneGroup',
            },
            {
                name: 'pricingAccountCompanyName',
                filterField: 'pricingAccountCompanyName',
                filterType: FilterType.Array,
                labelKey: 'AccountLane.pricingAccount',
            },
            {
                name: 'temperatureRange',
                componentName: 'EnumValue',
                allowedValuesEnum: LaneGroupTemperatureRange,
                filterField: 'temperatureRange',
                filterType: FilterType.Array,
                labelKey: 'AccountLane.temperatureRange',
            },
            {
                name: 'customerQuotation',
                filterField: 'customerQuotation',
                filterType: FilterType.Array,
                labelKey: 'AccountQuotes.customerQuotation',
            },
            {
                name: 'deliveryServiceType',
                componentName: 'EnumValue',
                allowedValuesEnum: DeliveryServiceType,
                labelKey: 'LaneGroupView.deliveryService',
            },
            {
                name: 'collectionServiceType',
                labelKey: 'LaneGroupView.collService',
                componentName: 'EnumValue',
                allowedValuesEnum: CollectionServiceType,
            },
            {
                name: 'originAirport',
                labelKey: 'OrderView.from',
            },
            {
                name: 'destinationAirport',
                labelKey: 'OrderView.to',
            },
            {
                name: 'laneStatus',
                componentName: 'EnumValue',
                allowedValuesEnum: LaneStatus,
                labelKey: 'LaneQuoteRequest.selectedLaneStatus',
            },
            {
                name: 'changedOn',
                labelKey: 'KamDashboard.lastUpdated',
                componentName: 'DateTimeCell',
            },
        ],
    }],
}

export default toBeAssignedLanesConfig
